import PictureModal from './PictureModal';

export default PictureModal;
